<template>
	<div id="upload-file-content">
		<vx-card class="custom-heigh">
			<div class="vx-row">
				<div class="vx-col w-full flex items-center p-2">
					<feather-icon
						class="g-breadcrumb--title"
						icon="ChevronLeftIcon"
						svgClasses="h-8 w-8"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					/>
					<vs-breadcrumb
						class="g-breadcrumb--title"
						separator=""
						:items="[{title: $t('general.Return')}]"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					></vs-breadcrumb>
				</div>
			</div>
			<bread-crumbs
				:title="$t('New') + ' ' + $t('UploadFiles.UploadFiles')"
				:subTitle="$t('general.SubtitleUploadFileCreate')"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<div
				class="vx-row m-0"
				style="border: 1px solid #cbcbcb; box-sizing: border-box; border-radius: 10px; padding: 20px"
			>
				<div
					:class="
						enableRole || (uploadType && uploadType.value === 'VISIT_POINT')
							? 'vx-col md:w-1/4 w-full'
							: isTypeLayer
							? 'vx-col w-full'
							: 'vx-col md:w-1/3 w-full'
					"
				>
					<vs-tooltip position="top" color="primary" :text="$t('UploadFiles.UploadTypeSelectToltip')">
						<label class="g-label" v-text="$t('UploadFiles.UploadType')"></label>
						<v-select
							v-model="uploadType"
							:clearable="false"
							:options="uploadTypeOptions"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:placeholder="$t('Select')"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</vs-tooltip>
				</div>
				<div
					:class="
						enableRole || (uploadType && uploadType.value === 'VISIT_POINT')
							? 'vx-col md:w-1/4 w-full'
							: 'vx-col md:w-1/3 w-full'
					"
					v-show="!isTypeLayer"
				>
					<vs-tooltip position="top" color="primary" :text="$t('UploadFiles.UploadTypeObjectToltip')">
						<label class="g-label">{{ $t("ObjectType") }}</label>
						<v-select
							v-model="selectedTypology"
							:clearable="false"
							:disabled="typologies.length <= 0 && !uploadType"
							:options="typologies"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:placeholder="$t('Select')"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
					</vs-tooltip>
				</div>
				<div class="vx-col md:w-1/4 w-full" v-if="enableRole">
					<label class="g-label">{{ $t("Role") }}</label>
					<v-select
						v-model="selectedRole"
						:clearable="false"
						:options="roles"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:placeholder="$t('Select')"
					>
						<template v-slot:no-options="{search, searching}">
							<template v-if="searching">
								{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
							</template>
						</template>
					</v-select>
				</div>
				<div
					:class="
						(enableRole && selectedTypology) || (uploadType && uploadType.value === 'VISIT_POINT')
							? 'vx-col md:w-1/4 w-full'
							: 'vx-col md:w-1/3 w-full'
					"
					v-show="selectedTypology && uploadType.value !== 'LAYER'"
				>
					<vs-tooltip color="success" :text="$t('UploadFiles.DownloadFormatText')" position="top">
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<vs-button class="btn-drop mt-6 w-full" type="filled" icon="expand_more" icon-after
								><span
									class="btn--span-text"
									v-text="
										uploadType &&
										(uploadType.value === 'RESOURCE' || uploadType.value === 'VISIT_POINT')
											? $t('ManualData.Download')
											: $t('UploadFiles.DownloadFormat')
									"
								></span>
							</vs-button>
							<vs-dropdown-menu class="w-64">
								<vs-dropdown-item
									v-for="field in fieldTypes"
									:key="field.value"
									@click.prevent="downloadFileBasic(field.label)"
								>
									<div class="flex flex-wrap items-center w-full">
										<i class="material-icons inline-block mr-2">
											{{ field.icon }}
										</i>
										<span class="mr-2">{{ $t("UploadFiles.Format") }}</span>
										<span class="font-bold">{{ field.label }}</span>
									</div>
								</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
						<span></span>
					</vs-tooltip>
				</div>
			</div>
			<div class="vx-row">
				<div :class="dataFile ? 'vx-col md:w-3/4 w-full' : 'vx-col md:w-4/4 w-full'">
					<vs-input id="file-upload" type="file" class="mt-3 w-full mb-4" @change="onFileChange" />
					<div class="custom-file-upload" for="file-upload">
						<label for="file-upload" :class="uploadStatus">
							<feather-icon
								style="background: rgba(0, 122, 235, 0.1); color: #0b8ff4"
								class="cursor-pointer mr-2 rounded-full p-6"
								:icon="this.dataFile ? 'PaperclipIcon' : 'UploadIcon'"
								svgClasses="h-12 w-12"
							/>
						</label>
						<label for="file-upload" class="g-label mt-2 text-center" :class="uploadStatus">
							{{ this.dataFile ? this.fileName : $t("general.SelectYourFile") }} <br />
							<small v-if="!this.dataFile" class="text-xs">{{ ".xlsx, .xls, .csv, .json, .xml" }}</small>
						</label>
					</div>
					<div class="mt-4">
						<vs-progress :height="12" :percent="progressPercent" :color="progressColor"></vs-progress>
					</div>
					<p class="mt-4 mb-base">
						<vs-alert
							:active.sync="activeAlert"
							closable
							icon-pack="feather"
							close-icon="icon-x"
							color="primary"
							:title="$t('UploadFiles.UploadSuccess')"
						>
							{{ $t("UploadFiles.UploadSuccessTextAlert") }}
						</vs-alert>
					</p>
				</div>
				<div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4">
					<vx-card no-shadow v-if="dataFile">
						<template slot="no-body">
							<div class="p-8 clearfix">
								<div>
									<h1>
										<sup></sup>
										<span class="g-subtitle">{{ $t("UploadFiles.Details") }}</span>
									</h1>
									<small>
										<span class="g-label">{{ $t("Name") }}: </span>
										<span class="g-table--description">{{ dataFile.name }}</span>
									</small>
								</div>
								<p
									class="mt-2 mb-8 g-tools--description"
									:class="10 >= 0 ? 'text-primary' : 'text-danger'"
								>
									<span>{{ $t("UploadFiles.Size") }}:</span>
									<span class="ml-1">{{ fileSize }}</span>
								</p>
								<vs-alert
									:active="!validateFileTypes"
									:title="$t('UploadFiles.InvalidFormatFile')"
									color="danger"
									icon="new_releases"
									class="mt-2"
								>
									{{ $t("UploadFiles.InvalidFormatFileText") }}
								</vs-alert>
							</div>
							<div
								class="
									p-8
									border
									d-theme-border-grey-light
									border-solid border-r-0 border-l-0 border-b-0
								"
							>
								<div class="mb-1">
									<small class="g-label--normal">{{ $t("UploadFiles.FileReadyToBeUploaded") }}</small>
								</div>
							</div>
						</template>
					</vx-card>
				</div>
			</div>
			<div class="vx-row flex justify-end">
				<div class="vx-col">
					<div class="mt-4 flex items-center justify-end">
						<vs-button
							class="mr-2 g-btn--resourcePopup"
							type="border"
							color="danger"
							style="padding: 0.7rem 3.5rem"
							@click.prevent="cleanData"
							>{{ $t("Cancel") }}
						</vs-button>
						<vs-button
							id="btn-submit-upload"
							class="vs-con-loading__container ml-4 g-btn--resourcePopup"
							type="filled"
							color="success"
							:disabled="enableUploadBtn || !validateFileTypes"
							@click.prevent="handleUpload"
							>{{ $t("Upload") + " " + $t("general.Archive") }}
						</vs-button>
					</div>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";
import firebase from "firebase/app";
import "firebase/storage";
import {uploadFileToFirebase} from "@/helpers/firebaseDB.js";
import moduleResource from "@/store/resource/moduleResource.js";
import Commons from "@/helpers/commons.js";
import UploadFile from "@/models/UploadFile.js";
import ManageErrorMessages from "@/models/ManageErrorMessages.js";
import moduleCommon from "@/store/common/moduleCommon.js";

export default {
	components: {
		vSelect,
	},
	data() {
		return {
			storageRef: firebase.storage(),
			firebasePath: null,
			percent: 0,
			dataFile: null,
			fileName: "",
			textStatus: "",
			progressColor: "#0B8FF4",
			selectedTypology: null,
			firesbaseResponse: {
				downloadURL: "",
				bucketPath: "",
			},
			uploadType: null,
			uploadTypeOptions: [
				{label: this.$t("VisitPoints"), value: "VISIT_POINT"},
				{label: this.$t("Resources"), value: "RESOURCE"},
				{label: this.$t("Schedule.Schedules"), value: "SCHEDULE"},
				{label: this.$t("Zonification.Layers"), value: "LAYER"},
			],
			dataCategory: [],
			dataRoles: [],
			enableRole: false,
			selectedRole: null,
			activeAlert: false,
			isTypeLayer: false,
			manageErrorMessages: new ManageErrorMessages({that: this}),
		};
	},
	computed: {
		enableUploadBtn() {
			if (this.enableRole) {
				return (
					!this.dataFile ||
					this.selectedTypology === null ||
					this.uploadType === null ||
					this.selectedRole === null
				);
			} else if (this.uploadType && this.uploadType.value === "LAYER") {
				return !this.dataFile;
			} else if (this.uploadType && this.uploadType.value === "VISIT_POINT") {
				return !this.dataFile || this.selectedTypology === null;
			} else {
				return !this.dataFile || this.selectedTypology === null || this.uploadType === null;
			}
		},
		validateFileTypes() {
			return (
				this.dataFile &&
				(this.dataFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
					this.dataFile.type === "application/json" ||
					this.dataFile.type === "text/csv" ||
					this.dataFile.type === "text/xml")
			);
		},
		uploadStatus() {
			if (this.textStatus === "success") return "text-primary";
			else if (this.textStatus === "error") return "text-danger";
			else return "";
		},
		typologies() {
			return Commons.generateSelectOptios(this.dataCategory, "typology_name", "typology_id");
		},
		roles() {
			return Commons.generateSelectOptios(
				this.dataRoles.filter((r) => r.name !== "GOTU"),
				"name",
				"id"
			);
		},
		fileSize() {
			const fileBytes = this.dataFile.size;
			if (fileBytes >= 1073741824) {
				return (fileBytes / 1073741824).toFixed(2) + " GB";
			} else if (fileBytes >= 1048576) {
				return (fileBytes / 1048576).toFixed(2) + " MB";
			} else if (fileBytes >= 1024) {
				return (fileBytes / 1024).toFixed(2) + " KB";
			} else if (fileBytes > 1) {
				return fileBytes + " bytes";
			} else if (fileBytes == 1) {
				return fileBytes + " byte";
			} else {
				return "0 bytes";
			}
		},
		progressPercent: {
			get() {
				return this.$store.state.uploadFile.uploadProgress;
			},
			set(val) {
				this.percent = val;
				this.$store.commit("uploadFile/incrementProgress", val);
			},
		},
		fieldTypes() {
			return [
				{
					label: `xlsx`,
					icon: "arrow_right",
				},
				{
					label: `csv`,
					icon: "arrow_right",
				},
				{
					label: `json`,
					icon: "arrow_right",
				},
				{
					label: `xml`,
					icon: "arrow_right",
				},
			];
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		handleUpload() {
			const uploadType = this.uploadType.value;
			const uploadTypeObject = {
				VISIT_POINT: "/uploads/visit_point/",
				RESOURCE: "/uploads/resource/",
				SCHEDULE: "/uploads/schedule/",
				LAYER: "/uploads/layer/",
			};
			this.firebasePath = uploadTypeObject[uploadType] || null;
			this.uploadOtherFile();
		},
		successUpload() {
			this.$vs.notify({
				color: "success",
				title: this.$t("UploadFiles.UploadSuccess"),
				text: this.$t("UploadFiles.UploadSuccessMessage"),
			});
		},
		errorUploadNotify(message) {
			this.$vs.notify({
				color: "danger",
				title: "Upload Error",
				text: message,
			});
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.dataFile = files[0];
			this.fileName = this.dataFile.name;
			this.percent = 0;
			this.textStatus = "success";
			this.progressColor = "success";
		},
		/**
		 * TODO: Subir arcchivos de tipologias LAYER
		 */
		uploadCapasFile() {
			if (!this.dataFile) {
				return;
			}
			let uploadFile = null;
			let rawData = {
				category: "LAYER",
			};
			rawData = JSON.stringify(rawData);
			let formData = new FormData();
			formData.append("file", this.dataFile, this.dataFile.name);
			formData.append("category", "LAYER");
			this.$store
				.dispatch("uploadFile/uploadFileServive", formData)
				.then((res) => {
					Object.assign(this.firesbaseResponse, res);
					return this.$store.dispatch("uploadFile/cartoimport", {
						url_file: res.url,
					});
				})
				.then((response) => {
					const payload = {
						bucket_path: this.firesbaseResponse.bucket_path,
						url_file: this.firesbaseResponse.downloadURL,
						original_name: this.fileName,
						typology_id: this.selectedTypology.value,
						job_id: response.item_queue_id,
						public: true,

						upload_type: this.uploadType.value,
						object_type: this.selectedTypology.label,
					};
					uploadFile = new UploadFile(payload);
					return this.$store.dispatch("uploadFile/saveUploadFile", uploadFile);
				})
				.then((res) => {
					this.successUpload();
					this.cleanData();
					this.activeAlert = true;
				})
				.catch((error) => {
					this.textStatus = "error";
					this.progressColor = "danger";

					if (Object.hasOwnProperty.call(error, "code")) {
						this.manageErrorMessages.setErrorMessage(error.code);
					}
					if (Object.hasOwnProperty.call(error, "data")) {
						this.status = false;
					}
					this.manageErrorMessages.showMessage();
				});
		},
		/**
		 * TODO: Subir arcchivos de tipologias VISIT_POINT , RESOURCE o SCHEDULE
		 */
		uploadOtherFile() {
			const fileExt = this.dataFile.name.split(".").pop();
			if (!this.dataFile) {
				return;
			}
			if (this.uploadType.value === "LAYER" && fileExt !== "json" && fileExt !== "geojson") {
				this.$vs.notify({
					time: 7000,
					title: this.$t("UploadFiles.InvalidFormatFile"),
					text:
						this.$t("MassiveAssignment.LoadMassiveAssignmentUploadFileError") +
						" " +
						this.$t("Upload") +
						" .json, .geojson",
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
				return;
			}
			let uploadFile = null;
			uploadFileToFirebase
				.call(this, this.dataFile, this.firebasePath)
				.then((res) => {
					Object.assign(this.firesbaseResponse, res);
					const payload = {
						bucket_path: this.firesbaseResponse.bucketPath,
						url_file: this.firesbaseResponse.downloadURL,
						original_name: this.fileName,
						typology_id: this.selectedTypology.value,
						public: true,
						upload_type: this.uploadType.value,
						object_type: this.selectedTypology.label,
					};
					if (this.uploadType.value === "RESOURCE") {
						payload["role_id"] = this.selectedRole.value;
					}
					uploadFile = new UploadFile(payload);
					return this.$store.dispatch("uploadFile/saveUploadFile", uploadFile);
				})
				.then((res) => {
					const uploaded = res;
					if (this.uploadType.value === "RESOURCE") {
						uploaded["role_id"] = this.selectedRole.value;
					}
					this.$store.commit("uploadFile/SAVE_UPLOAD", uploaded);
					uploadFile.id = res.id;
					this.successUpload();
					this.cleanData();
					this.$emit("uploadStatusEmit", true);
				})
				.catch((error) => {
					this.textStatus = "error";
					this.progressColor = "danger";
					if (Object.hasOwnProperty.call(error, "code")) {
						this.manageErrorMessages.setErrorMessage(error.code);
					}
					if (Object.hasOwnProperty.call(error, "data")) {
						this.status = false;
					}
					this.manageErrorMessages.showMessage();
				});
		},
		cleanData() {
			(this.fileName = this.$t("Zonification.UploadZones.FileName")), (this.dataFile = null);
			this.textStatus = "";
			this.progressColor = "primary";
			this.status = null;
			this.$store.commit("uploadFile/resetProgress");
		},
		/**
		 * TODO: Consumo de servicio para obtener las categorias o los objetos
		 * @param {String} category nombre del tipo tipologia seleccionada
		 */
		fetchDataCategory(category) {
			const payload = {
				role: [],
				category,
				typology: [],
			};
			this.openLoading();
			this.$store
				.dispatch("moduleResource/fetchDataSelect", payload)
				.then((res) => {
					this.dataCategory = res.data.category;
					this.dataRoles = res.data.role;
					if (this.uploadType.label === "LAYER") {
						const {typology_id, typology_name} = this.dataCategory[0];
						this.selectedTypology = {value: typology_id, label: typology_name};
						this.isTypeLayer = true;
					}
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					if (err.status === 400 && Object.hasOwnProperty.call(err, "data")) {
						this.manageErrorMessages.setErrorMessage(err.data.reason);
					}
					this.manageErrorMessages.showMessage();
				});
		},
		showSuccessUpload() {
			this.activeAlert = true;
		},
		handleUploadError(error) {
			switch (error.code) {
				case "storage/unauthorized":
					// User doesn't have permission to access the object
					this.errorUploadNotify("User doesn't have permission to access the object");
					break;
				case "storage/canceled":
					// User canceled the upload
					this.errorUploadNotify("User canceled the upload");
					break;
				case "storage/unknown":
					// Unknown error occurred, inspect error.serverResponse
					// "Ocurrió un error inesperado durante la carga del archivo"
					this.errorUploadNotify("Unknown error occurred, inspect error.serverResponse");
					break;
			}
		},
		/**
		 * TODO: Consumo de servicio de descarga de archivo
		 * @param {String} type_file nombre del tipo de archivo a descargar
		 * !Note: Cuando el usuario seleccinoa xlsx lo tratamos como un json y la conversion se hace desde el fron
		 */
		downloadFileBasic(type_file) {
			const payload = {
				typology_id: this.selectedTypology.value,
				type_file: type_file === "xlsx" ? "json" : type_file,
			};
			this.openLoading();
			this.$store
				.dispatch("uploadFile/downloadFileFormat", payload)
				.then((res) => {
					this.closeLoading();
					this.manageExport(res, `.${type_file}`);
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.setTitle(this.$t("UploadFiles.DownloadFormat"));
					if (err.status === 400 && Object.hasOwnProperty.call(err, "data")) {
						this.manageErrorMessages.setErrorMessage(err.data.reason);
					}
					this.manageErrorMessages.showMessage();
				});
		},
		/**
		 * TODO: Gestionar que tipo de exportacion se va hacer
		 * @param {String} data datos obtenidos del servicio de descarga
		 * @param {any} type extencion del archivo a exportar
		 */
		manageExport(data, type) {
			if (type === ".json") {
				this.exportToJson(data);
			} else if (type === ".xlsx") {
				this.exportToExcel(data);
			} else if (type === ".csv" || type === ".xml") {
				this.exportToCsvOrXml(data, type);
			}
		},
		/**
		 * TODO: Exportar de datos a formato CSV o XML
		 * @param {String} data datos obtenidos del servicio de descarga
		 * @param {any} type extencion del archivo a exportar
		 */
		exportToCsvOrXml(data, type) {
			const file = new Blob([data], {type: type});
			if (window.navigator.msSaveOrOpenBlob)
				// IE10+
				window.navigator.msSaveOrOpenBlob(file, this.selectedTypology.label);
			else {
				const url = window.URL.createObjectURL(file);
				const a = document.createElement("a");
				a.style.display = "none";
				a.href = url;
				a.download = this.selectedTypology.label + type;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			}
		},
		/**
		 * TODO: Exportar de datos a formato JSON
		 * @param {String} data datos obtenidos del servicio de descarga
		 * @param {any} type extencion del archivo a exportar
		 */
		exportToJson(exportObj) {
			const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
			const downloadAnchorNode = document.createElement("a");
			downloadAnchorNode.setAttribute("href", dataStr);
			downloadAnchorNode.setAttribute("download", this.selectedTypology.label + ".json");
			document.body.appendChild(downloadAnchorNode); // required for firefox
			downloadAnchorNode.click();
			downloadAnchorNode.remove();
		},
		/**
		 * TODO: Exportar de datos a formato EXCEL
		 * @param {String} data datos obtenidos del servicio de descarga
		 * @param {any} type extencion del archivo a exportar
		 */
		exportToExcel(jsonData) {
			import("@/vendor/Export2Excel").then((excel) => {
				const list = jsonData;
				const headerVal = Object.keys(jsonData[0]);
				const data = this.formatJson(headerVal, list);
				excel.export_json_to_excel({
					header: headerVal,
					data,
					filename: this.selectedTypology.label,
					autoWidth: true,
					bookType: "xlsx",
				});
			});
		},
		/**
		 * TODO: Filtrar y convertir la data a un array para exportar a excel
		 * @param {Array} filterVal array con la informacion de las keys del archivo
		 * @param {JSON} jsonData datos obtenidos del servicio
		 */
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]));
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
	},
	watch: {
		uploadType(val) {
			this.selectedTypology = null;
			this.selectedRole = null;
			if (val) this.fetchDataCategory(val.value);
			val.value === "RESOURCE" ? (this.enableRole = true) : (this.enableRole = false);
			if (val.value === "LAYER") {
				this.isTypeLayer = true;
			} else {
				this.isTypeLayer = false;
			}
			this.cleanData();
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		this.$store.commit("uploadFile/resetProgress");
	},
};
</script>

<style lang="scss" scope>
#upload-file-content {
	height: 100%;
}

input[type="file"] {
	display: none;
}

.custom-file-upload {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px dashed #cbcbcb;
	box-sizing: border-box;
	border-radius: 10px;
	height: 267px;
}

.feather-upload {
	stroke-width: 4;
}

.custom-heigh {
	height: 95vh;
}
</style>
